"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ClearAll_exports = {};
__export(ClearAll_exports, {
  default: () => ClearAll_default
});
module.exports = __toCommonJS(ClearAll_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 5.2H9C8.74819 5.2 8.51108 5.31856 8.36 5.52L3.86 11.52C3.64667 11.8044 3.64667 12.1956 3.86 12.48L8.36 18.48C8.51108 18.6814 8.74819 18.8 9 18.8H20C20.4418 18.8 20.8 18.4418 20.8 18V6C20.8 5.55817 20.4418 5.2 20 5.2ZM9 4C8.37049 4 7.77771 4.29639 7.4 4.8L2.9 10.8C2.36667 11.5111 2.36667 12.4889 2.9 13.2L7.4 19.2C7.77771 19.7036 8.37049 20 9 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H9ZM10.6111 15.4293C10.3768 15.195 10.3768 14.8151 10.6111 14.5807L13.1567 12.0352L10.5757 9.45426C10.3414 9.21994 10.3414 8.84004 10.5757 8.60573C10.81 8.37141 11.1899 8.37141 11.4243 8.60573L14.0052 11.1867L16.6111 8.58075C16.8454 8.34643 17.2253 8.34643 17.4597 8.58075C17.694 8.81506 17.694 9.19496 17.4597 9.42927L14.8537 12.0352L17.4243 14.6057C17.6586 14.84 17.6586 15.2199 17.4243 15.4543C17.1899 15.6886 16.81 15.6886 16.5757 15.4543L14.0052 12.8837L11.4597 15.4293C11.2253 15.6636 10.8454 15.6636 10.6111 15.4293Z",
      fill: "currentColor"
    }
  )
);
const SvgClearAll = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ClearAll_default = SvgClearAll;
